import type { Enums } from "../database.types.ts"

export const EMPLOYER_RESTRICTED_AREAS: readonly Enums<"person_areas">[] = [
  "Rc1 Deliveries",
  "Rc2 Deliveries",
]

// Taken from the person_employer enum so a rename in the DB fails the build here
export const HIVED_EMPLOYER: Enums<"person_employer"> = "HIVED"

export const isEmployerRestrictedArea = (area: Enums<"person_areas">): boolean =>
  EMPLOYER_RESTRICTED_AREAS.includes(area)

/**
 * Allowed employers for an area. `knownEmployers` is the team/DSP list from the caller's own source
 * (useSubTeams on the frontend, the tables on the backend).
 */
export const isEmployerAllowedForArea = (
  area: Enums<"person_areas">,
  employer: string,
  knownEmployers: readonly string[],
): boolean => {
  const value = employer.trim()
  if (!value) return false
  if (!isEmployerRestrictedArea(area)) return true
  if (value === HIVED_EMPLOYER) return true

  return knownEmployers.some((known) => known.trim() === value)
}

export const employerNotAllowedForAreaError = (employer: string): string =>
  `"${employer}" is not allowed. Use a driver manager team or a DSP.`
